const BACKEND = process.env.REACT_APP_CAREERS_API || "https://api.carrers.guebly.com.br";

export async function getJobs() {
  const res = await fetch(`${BACKEND}/api/jobs`);
  const data = await res.json();
  return data.data || [];
}

export async function getJob(slug) {
  const res = await fetch(`${BACKEND}/api/jobs/${slug}`);
  if (!res.ok) return null;
  const data = await res.json();
  return data.data || null;
}

export async function submitApplication(formData) {
  const res = await fetch(`${BACKEND}/jobs/apply`, {
    method: "POST",
    body: formData,
  });
  return res.json();
}
